import exame from '@/repositories/conecta-sus/parametrizacao/exameRepository'
import kitExame from '@/repositories/conecta-sus/parametrizacao/kitExameRepository'
import procedimento from '@/repositories/conecta-sus/parametrizacao/procedimentoRepository'
import procedimentoCirurgico from '@/repositories/conecta-sus/parametrizacao/procedimentoCirurgicoRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/parametrizacao`

    return {
        exame: exame(baseUrl),
        kitExame: kitExame(baseUrl),
        procedimento: procedimento(baseUrl),
        procedimentoCirurgico: procedimentoCirurgico(baseUrl),
    }
}
